<mat-sidenav-container class="sidenav-container">
    <mat-sidenav
        #leftDrawer
        [(opened)]="opened"
        (opened)="events.push('open!')"
        (closed)="events.push('close!')"
        class="menu-panel"
        position="start"
    >
        <ng-template
            [cdkPortalOutlet]="mobileDrawerService.drawerPortal | async"
        ></ng-template>
    </mat-sidenav>

    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>

    <mat-sidenav
        #rightDrawer
        class="panel"
        position="end"
        autoFocus="false"
        [disableClose]="true"
    >
        <ng-template
            [cdkPortalOutlet]="drawerService.drawerPortal | async"
        ></ng-template>
    </mat-sidenav>
</mat-sidenav-container>
